import live from './live.js';

function v2(backendAxiosInstance) {
  return {
    ...live(backendAxiosInstance)
  };
}

export { v2 as default };
//# sourceMappingURL=index.js.map
